@import '../../themes/capsule.globals';

:host {
  --container-gap: 8px;

  --container-padding-top: 8px;
  --container-padding-bottom: 8px;
  --container-padding-start: 8px;
  --container-padding-end: 8px;

  --container-font-size: var(--cpsl-font-size-body-s);

  --container-border-width: 1px;
  --container-border-radius: var(--cpsl-border-radius-alert);

  --container-background-color: var(--cpsl-color-background-0);
  --container-color: var(--cpsl-color-text-primary);
  --container-icon-color: var(--container-color);

  --container-align-items: center;
  --container-justify-content: center;

  --title-container-gap: 8px;

  --title-container-align-items: flex-start;
  --title-container-justify-content: center;

  display: inline-block;
  font-family: $font-family-base;
  position: relative;
}

:host(.error) {
  --container-color: var(--cpsl-color-black);
  --container-icon-color: var(--cpsl-color-utility-red);
  --container-border-color: var(--cpsl-color-alert-border-error, var(--cpsl-color-utility-red));

  &:host(.filled) {
    --container-background-color: var(--cpsl-color-alert-surface-error, var(--cpsl-color-utility-red-light));
  }
}

:host(.warning) {
  --container-color: var(--cpsl-color-black);
  --container-icon-color: var(--cpsl-color-utility-yellow);
  --container-border-color: var(--cpsl-color-utility-yellow);

  &:host(.filled) {
    --container-background-color: var(--cpsl-color-utility-yellow-light);
  }
}

:host(.success) {
  --container-color: var(--cpsl-color-black);
  --container-icon-color: var(--cpsl-color-utility-green);
  --container-border-color: var(--cpsl-color-utility-green);

  &:host(.filled) {
    --container-background-color: var(--cpsl-color-utility-green-light);
  }
}

:host {
  cpsl-icon {
    --icon-color: var(--container-icon-color);
    --height: 24px;
    --width: 24px;
  }
}

.alert-container {
  @include border-radius(var(--container-border-radius));
  @include padding(var(--container-padding-top), var(--container-padding-end), var(--container-padding-bottom), var(--container-padding-start));

  font-size: var(--container-font-size);

  display: flex;
  flex-direction: column;
  align-items: var(--container-align-items);
  justify-content: var(--container-justify-content);
  gap: var(--container-gap);

  border-style: solid;
  border-width: var(--container-border-width);
  border-color: var(--container-border-color);

  background-color: var(--container-background-color);
  color: var(--container-color);
}

.title-container {
  display: flex;
  align-items: var(--title-container-align-items);
  justify-content: var(--title-container-justify-content);
  gap: var(--title-container-gap);
}
